import Http from "./http";

export const getEnrollmentAgreementDetailsAPI = (payload) => {
  return Http.post("admin/campaign/enrollment-agreement/get", payload);
};

